import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    description: 'verify email modal header',
    defaultMessage: 'Verify Email Address',
    id: 'Dw7DTD',
  },
  line1: {
    description: 'verify email modal description line 1',
    defaultMessage:
      'ShipStation can send outbound shipment confirmation notices from your email address, but we first need to verify ownership of the email account.',
    id: 'fTLAQD',
  },
  line2: {
    description: 'verify email modal description line 2',
    defaultMessage:
      'In order to utilize your email address as a sending address, we will send an email to your address with a link to follow.',
    id: 'ThAyCZ',
  },
  line3: {
    description: 'verify email modal description line 3',
    defaultMessage: 'You must follow the brief instructions in the email in order to verify your address.',
    id: 'Bjjdqa',
  },
  line4: {
    description: 'verify email modal description line 4',
    defaultMessage: 'Click the "Send Confirmation" button to send the confirmation email to <b>{email}</b>',
    id: 'x+IB2v',
  },
  sendConfirmation: {
    description: 'verify email modal send confirmation button',
    defaultMessage: 'Send Confirmation Email',
    id: 'qFIDEJ',
  },
  error: {
    description: 'verify email address error',
    defaultMessage: 'There was a problem sending the confirmation email. Please try again.',
    id: 'x4uxVJ',
  },
});
